import { Button } from "@/components/ui/button";
import { House, RefreshCw, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ResourcesHero() {
  return <section data-section-id="256652" id="מטפל-סיעודי-באשדוד-פתרון-מיידי" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-accent/5 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        {}
        <div className="mb-8 p-4 bg-primary/5 rounded-lg backdrop-blur-sm shadow-md">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashdod_care_icon.png" alt="Caregiver Icon" className="h-12 w-auto" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashdod_care_icon.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/ashdod_care_icon.png-wvc-sizes" />
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 tracking-tight text-primary">
          מטפל סיעודי באשדוד תוך 5 שעות
        </h1>
        
        <p className="text-lg md:text-xl max-w-2xl mx-auto mb-10 text-muted-foreground font-default">
          זקוקים לעזרה דחופה? אנחנו מספקים מענה מיידי ומקצועי לסיעוד והשגחה באשדוד והסביבה, עם צוות מטפלים מיומן הזמין עבורכם ברגעים הקריטיים ביותר.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Button asChild variant="secondary" size="lg" className="rounded-lg shadow-lg">
            <Link to="/CaregiverServicePagesPage">
              <House className="mr-2 size-5" />
              מטפל סיעודי בבית
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="rounded-lg bg-transparent border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground shadow-md">
            <Link to="/CaregiverServicePagesPage2">
              <RefreshCw className="mr-2 size-5" />
              השגחה בבית חולים
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="rounded-lg bg-transparent border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground shadow-md">
            <Link to="/CitySpecificSEOPagesForNursingCareProviderPage">
              <FileText className="mr-2 size-5" />
              שירותים באשדוד
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}